export default __webpack_public_path__ + "static/media/Gallery6.06cd2b65.jpeg";